var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
        _c("div", { staticClass: "header-text" }, [
          _c("div", [
            _vm._v(
              "\n        赔付单号:" +
                _vm._s(_vm.detailInfo.head_data.pf_no) +
                "   \n        生成时间:" +
                _vm._s(_vm.detailInfo.head_data.created_at) +
                "   \n        赔付单状态：\n        "
            ),
            _c(
              "span",
              {
                style: {
                  color:
                    _vm.detailInfo.head_data.status === _vm.STATUS_AGAIN_SUBMIT
                      ? "#f56c6c"
                      : "#000"
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.detailInfo.head_data.status_msg) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticClass: "card-block" }, [
            _c("div", { staticClass: "table-box" }, [
              _c("div", [
                _vm._v(
                  "\n          赔付单商品信息： 共 " +
                    _vm._s(_vm.detailInfo.head_data.total_goods_num) +
                    " 件\n          " +
                    _vm._s(_vm.detailInfo.head_data.total_pf_price) +
                    "元\n        "
                )
              ]),
              _vm._v(" "),
              _vm.isShowPayeeModuleButtonMarking
                ? _c(
                    "div",
                    { staticStyle: { "margin-left": "auto" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.handleMarking }
                        },
                        [_vm._v("\n            打标\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "mini" },
                          on: { click: _vm.handleMarkingSubmit }
                        },
                        [_vm._v("\n            提交打标数据并入库\n          ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.detailInfo.detail_list.length > 0
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.detailInfo.detail_list,
                          "tooltip-effect": "dark",
                          border: ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "dbid",
                            label: "打标id",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "psp_id",
                            label: "前置仓计划编号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            width: "80",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_img",
                            label: "商品图片",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: { src: scope.row.goods_img }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1325509903
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_kh",
                            label: "款号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            width: "80",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            width: "80",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            width: "80",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sku",
                            label: "sku编号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cat_name",
                            label: "商品分类",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_source",
                            label: "入库来源",
                            width: "80",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "is_on_sale_msg",
                            label: "商品状态",
                            width: "80",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exception_source",
                            label: "异常来源",
                            width: "80",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exception_admin",
                            label: "标记异常人",
                            width: "100",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exception_time",
                            label: "标记异常时间",
                            width: "120",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "original_market_price",
                            label: "原商家价",
                            width: "80",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "actual_market_price",
                            label: "实际赔付价",
                            width: "120",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  var $index = ref.$index
                                  return [
                                    !row._showInputPrice
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: ![
                                                _vm.STATUS_WAIT_SUBMIT,
                                                _vm.STATUS_AGAIN_SUBMIT
                                              ].includes(
                                                _vm.detailInfo.head_data.status
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handlePriceButtonClick(
                                                  row,
                                                  $index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(row.actual_market_price)
                                            )
                                          ]
                                        )
                                      : _c("el-input", {
                                          attrs: { clearable: "" },
                                          on: {
                                            change: function($event) {
                                              return _vm.handlePriceInputEnter(
                                                row,
                                                $index
                                              )
                                            },
                                            focus: function($event) {
                                              return _vm.handlePriceInputFocus(
                                                row,
                                                $index
                                              )
                                            }
                                          },
                                          model: {
                                            value: row.actual_market_price,
                                            callback: function($$v) {
                                              _vm.$set(
                                                row,
                                                "actual_market_price",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "row.actual_market_price"
                                          }
                                        })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3317001116
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "diff_price",
                            label: "差额",
                            width: "80",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(scope.row.diff_price) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3037825524
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_in_price",
                            label: "入库金额",
                            width: "80",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "new_dbid",
                            label: "新打标ID",
                            width: "80",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "new_stock_source",
                            label: "新入库来源",
                            width: "90",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.isShowPayeeModule
            ? _c("el-col", { staticClass: "card-block" }, [
                _c("div", { staticClass: "table-box" }, [
                  _vm.isShowPayeeModuleTitle
                    ? _c("div", [
                        _vm._v("\n          收款人信息\n          "),
                        _vm.detailInfo.head_data.pay_tool === _vm.PAY_TOOL_SUB
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("(分账不需要选择收款信息)")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.detailInfo.head_data.pay_tool ===
                        _vm.PAY_TOOL_TRANSFER
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("(转账支付需要选择收款信息)")
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowPayeeModuleButton2
                    ? _c(
                        "div",
                        { staticStyle: { "margin-left": "auto" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "mini" },
                              on: { click: _vm.handleCompensateSubmit }
                            },
                            [_vm._v("\n            提交赔付单\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "info", size: "mini" },
                              on: { click: _vm.handleCancellation }
                            },
                            [_vm._v("\n            作废\n          ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isShowPayeeModuleButton
                    ? _c(
                        "div",
                        { staticStyle: { "margin-left": "auto" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "mini" },
                              on: { click: _vm.handleCompensatePass }
                            },
                            [_vm._v("\n            通过\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "info", size: "mini" },
                              on: { click: _vm.handleCompensateReject }
                            },
                            [_vm._v("\n            驳回\n          ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.detailInfo.payees.length > 0
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _vm.isShowPayeeModuleTable
                          ? _c(
                              "el-table",
                              {
                                ref: "multipleTable",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.payeesList,
                                  "tooltip-effect": "dark",
                                  border: ""
                                }
                              },
                              [
                                _vm.isShowPayeeModuleRadio
                                  ? _c("el-table-column", {
                                      attrs: {
                                        label: "选择",
                                        align: "center",
                                        width: "80"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: { label: row.id },
                                                    model: {
                                                      value:
                                                        _vm.compensateform
                                                          .payee_id,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.compensateform,
                                                          "payee_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "compensateform.payee_id"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(""))]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1573864441
                                      )
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "pay_contact",
                                    label: "收款人名称",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "pay_bank",
                                    label: "收款银行",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "cnap_name",
                                    label: "收款银行支行",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "pay_account",
                                    label: "收款账号",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShowPayeeModuleInput
                          ? _c("el-input", {
                              attrs: {
                                type: "textarea",
                                placeholder: "操作备注（200字以内）",
                                maxlength: "200",
                                rows: 2,
                                "show-word-limit": ""
                              },
                              model: {
                                value: _vm.compensateform.log_remark,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.compensateform,
                                    "log_remark",
                                    $$v
                                  )
                                },
                                expression: "compensateform.log_remark"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("el-col", { staticClass: "card-block" }, [
            _c("div", { staticClass: "table-box" }, [
              _c("div", [_vm._v("操作日志")])
            ]),
            _vm._v(" "),
            _vm.detailInfo.operate_log.length > 0
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.detailInfo.operate_log,
                          "tooltip-effect": "dark",
                          border: ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "操作人",
                            prop: "action_admin",
                            align: "center",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "action_type",
                            label: "操作方式",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "操作时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "action_desc",
                            label: "操作备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.recall_dbid.showDialog,
            "close-on-click-modal": false,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.recall_dbid, "showDialog", $event)
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("p", [
              _vm._v("\n        请扫描打标ID:"),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(" 已打标" + _vm.recall_dbid.dbids.length + "个"))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { "label-position": "right", "label-width": "60px" } },
            [
              _c(
                "div",
                { attrs: { label: "标号：" } },
                [
                  _c("el-input", {
                    ref: "recallInput",
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "输入标号" },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.enterRecallDbid.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.recall_dbid.inputValue,
                      callback: function($$v) {
                        _vm.$set(_vm.recall_dbid, "inputValue", $$v)
                      },
                      expression: "recall_dbid.inputValue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.recall_dbid.dbids, function(item, index) {
                  return _c(
                    "el-tag",
                    { key: item, staticStyle: { margin: "5px 10px 5px 0" } },
                    [
                      _vm._v("\n          " + _vm._s(item) + "\n          "),
                      _c("i", {
                        staticClass: "el-icon-close",
                        on: {
                          click: function($event) {
                            return _vm.handleRemoveDbid(index, item)
                          }
                        }
                      })
                    ]
                  )
                }),
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: { click: _vm.handleRecallDbid }
                },
                [_vm._v("全部撤标")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.recall_dbid.showDialog = false
                    }
                  }
                },
                [_vm._v("\n        结束\n      ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("赔付明细单详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1dd326c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1dd326c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CompensateListDetail.vue
// module id = null
// module chunks = 